// queryParmas is location.search
// ?hasExceptionGames=true
// ?hasExceptionGames=false

const hasExceptionGamesWithLocationSearch = serachParams => {
  const params = new URLSearchParams(serachParams)
  const hasExceptionGames = params.get('hasExceptionGames')

  return hasExceptionGames === 'true'
}

const setExceptedGamesToSessionStorage = () => {
  if (
    hasExceptionGamesWithLocationSearch(location.search) &&
    !hasExceptionGamesFromSessionStorage()
  ) {
    sessionStorage.setItem('hasExceptionGames', true)
  }
}

const hasExceptionGamesFromSessionStorage = () => {
  return sessionStorage.getItem('hasExceptionGames') === 'true'
}

export { hasExceptionGamesFromSessionStorage, setExceptedGamesToSessionStorage }
